rivets.formatters.and = function(a,b) {
    return a && b;
}
rivets.formatters.or = function(a,b) {
    return a || b;
}
rivets.formatters.nullOr = function(a,b) {
    return a ?? b;
}
rivets.formatters.toLowerCase = function(a) {
    if (a) {
        return a.toLowerCase();
    }
    return a;
}
rivets.formatters.incAll = function(a,b) {
    return a + b;
}
rivets.formatters.empty = function(a) {
    if (typeof a == 'object') {
        return !Object.values(a).length
    }
    return !a.length
}
rivets.formatters.itemProperties = function(item) {
    if (item.properties) {
        return Object.entries(item.properties).map(([key,value])=>{return `${key}:${value}`}).join(',');
    }
    return [];
}
rivets.formatters.translateVariantTitle = function(variant_title, key, fallback) {
    if (!variant_title) { return '' };
    let splitArr = variant_title.split('/').map(s=>s.toLowerCase().trim());
    let translationArr = splitArr.map((str)=>{
        let translation = rivets.formatters.translate(str, key, fallback);
        if (translation == fallback) {
            return false;
        }
        return rivets.formatters.capitalize(translation);
    })
    let failedIndex = null;
    let hasFailedTranslation = translationArr.some((item,index)=>{
        failedIndex = index;
        return item == false;
    });
    if (hasFailedTranslation) {
        console.warn(`Translation missing: ${key}.${splitArr[failedIndex]}`)
        return rivets.formatters.capitalize(fallback);;
    }
    return translationArr.join(' / ');
}
rivets.formatters.translate = function(item,key,fallback) {
    let keyCode = Weglot.getCurrentLang();
    let keyArr = key.split('.');
    //use key to find translation object
    let translationObj = keyArr.reduce((prev,cur)=>{
        prev = prev[cur]
        return prev;
    },window.translations);
    //find item in translation object
    Object.keys(translationObj).forEach((key)=>{
        if (key.toLowerCase() == item.toLowerCase()) {
            item = key;
            return;
        }
    })
    let translation = translationObj[item]? translationObj[item][keyCode]: undefined;
    if (translation) {
        return translation;
    }
    let errorStr = `Translation missing: ${key}.${item}.${keyCode}`;
    if (!fallback) {
        console.error(errorStr)
        return errorStr;
    } else {
        return fallback;
    }
}


rivets.formatters.capitalize = function(str) {
    return str && str[0].toUpperCase() + str.slice(1);
}
